import { GetterTree } from 'vuex';
import { ArticleState } from './types';
import { RootState } from '@/store/types';
import { ArticleQueryParams } from '@/api/requests/article/types';

export const getters: GetterTree<ArticleState, RootState> = {
    /**
     * Check if article module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    articleModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('articles');
    },

    /**
     * Get the active article.
     *
     * @param state
     * @param myGetters
     */
    activeArticle: (state, myGetters) => {
        return myGetters.getArticleById(state.activeArticleId);
    },

    /**
     * Return the specified article.
     *
     * @param state
     */
    getArticleById: (state) => (id: number) => {
        return state.articles.find((article) => article.id === id);
    },

    /**
     * Check if article is in collection.
     *
     * @param state
     * @param myGetters
     */
    isArticleLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getArticleById(id);
    },

    /**
     * Get the active article.
     *
     * @param state
     * @param myGetters
     */
    activePriceList: (state, myGetters) => {
        return myGetters.getPriceListById(state.activePriceListId);
    },

    /**
     * Return the specified article.
     *
     * @param state
     */
    getPriceListById: (state) => (id: number) => {
        return state.priceLists.find((priceList) => priceList.id === id);
    },

    /**
     * Check if price list is in collection.
     *
     * @param state
     * @param myGetters
     */
    isPriceListLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getPriceListById(id);
    },

    /**
     * Get http filters.
     *
     * @param state
     */
    httpFilters: (state): ArticleQueryParams => ({
        ...state.filters,
        active: state.filters.active,
    }),
};
